/**
 * @generated SignedSource<<026ea9e3c249a20443e23e250f045799>>
 * @relayHash e5e993154e8ff794fa2941e8db114aac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a9f95fdbb33ed6ec2173e84be5621e770d68c2135d4f2ad935657b2adc0d0670

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type SettingsMenuItemInput = {
  menuId: string;
  visible: boolean;
};
export type SettingsDisplayPropertyInput = {
  key: string;
  value: string;
};
export type useNavSettingsServiceMutation$variables = {
  entityAri: string;
  ownerAri: string;
  properties?: ReadonlyArray<SettingsDisplayPropertyInput | null | undefined> | null | undefined;
  sidebar?: ReadonlyArray<SettingsMenuItemInput | null | undefined> | null | undefined;
};
export type useNavSettingsServiceMutation$data = {
  readonly settings_updateNavigationCustomisation: {
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null | undefined;
        readonly visible: boolean | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useNavSettingsServiceMutation = {
  response: useNavSettingsServiceMutation$data;
  variables: useNavSettingsServiceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "properties"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sidebar"
},
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityAri",
        "variableName": "entityAri"
      },
      {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
      },
      {
        "kind": "Variable",
        "name": "properties",
        "variableName": "properties"
      },
      {
        "kind": "Variable",
        "name": "sidebar",
        "variableName": "sidebar"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "concreteType": "SettingsMenuItemConnection",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsMenuItem",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "menuId"
        },
        {
          "kind": "ScalarField",
          "name": "visible"
        }
      ]
    }
  ]
},
v6 = {
  "concreteType": "SettingsDisplayPropertyConnection",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsDisplayProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useNavSettingsServiceMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useNavSettingsServiceMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a9f95fdbb33ed6ec2173e84be5621e770d68c2135d4f2ad935657b2adc0d0670",
    "metadata": {},
    "name": "useNavSettingsServiceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b5a5863adf9d22a5a510899bf456bf50";

export default node;
